import script from "./BaseFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseFooter.vue?vue&type=script&setup=true&lang=ts"

import "./BaseFooter.vue?vue&type=style&index=0&id=27bed403&scoped=true&lang=scss"

import exportComponent from "/builds/digithia/escape-game/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27bed403"]])

export default __exports__